import type { ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import { CardFrame } from "./CardFrame";

export function FoldCard({
  title,
  summary,
  summaryClassName = "text-text-tertiary",
  open,
  onToggle,
  actions,
  children,
}: {
  title: string;
  summary?: ReactNode;
  summaryClassName?: string;
  open: boolean;
  onToggle: () => void;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <CardFrame className="p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <button
          type="button"
          className="flex min-w-0 flex-1 items-start gap-2 text-left"
          aria-expanded={open}
          onClick={onToggle}
        >
          <ChevronRight
            size={16}
            className={`mt-1 shrink-0 text-text-tertiary transition-transform ${open ? "rotate-90" : ""}`}
            aria-hidden
          />
          <span className="min-w-0">
            <span className="block font-medium text-text-primary" style={{ fontSize: "var(--font-body)" }}>
              {title}
            </span>
            {summary != null && (
              <span className={`block ${summaryClassName}`} style={{ fontSize: "var(--font-micro)" }}>
                {summary}
              </span>
            )}
          </span>
        </button>
        {actions}
      </div>
      {open && <div className="mt-3">{children}</div>}
    </CardFrame>
  );
}
